import { styled } from '@mui/material/styles';
import React from 'react';
import BaseSection from './BaseSection';
import { useTranslation } from 'react-i18next';
import TourTextRenderer from '../../Markdown/TourTextRenderer';
import AnswerButton from '../../Button/AnswerButton';
import { IQuizResponseVM } from '@lialo/core/lib/common';
import { Chapter, IImage, StopSection } from '@lialo/core/lib/models';
import routes from '@lialo/core/lib/pages/utils/routes';


const StyledDiv = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 auto',
}));

interface IProps {
  stopIndex: number;
  orderId: number;
  question?: string;
  answers: IQuizResponseVM[];
  images?: IImage[];
  hideSelected?: boolean;
}

const Task = (props: IProps) => {
  const { t } = useTranslation();
  const stopNumber = props.stopIndex + 1;

  if (props.question === undefined) {
    return null;
  }

  return (
    <BaseSection
      id={routes.generateTourContentHash(Chapter.stop, StopSection.task, props.orderId)}
      title={t('tour_content.task.title', { count: stopNumber })}
      images={props.images}
    >
      <TourTextRenderer source={props.question} />
      <StyledDiv>
        {props.answers.map((answer, idx) => (
          <AnswerButton disabled={true} key={idx} answer={answer} />
        ))}
      </StyledDiv>
    </BaseSection>
  );
};

export default Task;
